import { styled } from '@mui/material/styles';
import { Tooltip, TooltipProps } from '@mui/material';
import { StyledComponent } from '@emotion/styled';

interface OffsetProps {
	placement: NonNullable<TooltipProps['placement']>;
}

export interface CoreTooltipProps extends TooltipProps {
	variant?: 'black' | 'white';
}

const modifiers = [
	{
		name: 'offset',
		options: {
			offset: ({ placement }: OffsetProps) => {
				if (placement === 'top-start') {
					return [-16, -3];
				}

				if (placement === 'top-end') {
					return [16, -3];
				}

				return [];
			},
		},
	},
];

export const CoreTooltip: StyledComponent<CoreTooltipProps> = styled((props: CoreTooltipProps) => (
	<Tooltip
		{...props}
		enterTouchDelay={0}
		onClick={(e) => {
			e.stopPropagation();
			e.preventDefault();
		}}
		classes={{ popper: props.className }}
		PopperProps={{ modifiers }}
	/>
))(({ theme, variant }) => ({
	color: theme.colors.gray,
	transition: theme.transitions.create('color', {
		duration: theme.transitions.duration.short,
	}),

	'&:hover': {
		color: theme.colors.blue,
	},

	'& .MuiTooltip-arrow': {
		color: variant === 'white' ? theme.colors.white : theme.colors.black,
	},

	'& .MuiTooltip-tooltip': {
		...theme.typography.label,
		fontSize: '0.8em',
		borderRadius: 8,
		color: variant === 'white' ? theme.colors.grayBlue : theme.colors.white,
		padding: '8.9px 15px',
		backgroundColor: variant === 'white' ? theme.colors.white : theme.colors.black,
		boxShadow: variant === 'white' ? '0px 2px 4px 0px rgba(158, 163, 169, 0.50)': 'none'
	},
}));
